<template>
  <div class="grid grid-cols-2 gap-4">
    <vx-card :title="`${profile.name} (${profile.prefix}: ${profile.id})`">
      <div class="w-6/12">
      <bank-account-select
          @input="changeBankAccountHandler"
          :options="profile.bankAccounts"
          v-model="profile.bankAccount"></bank-account-select>
      </div>

      <div class="mt-5">
        <template v-if="profile.stpAccount !== null">
          <h6>Cuenta Stp: </h6>
          <p>
            <stp-account-status-icon :status="profile.stpAccount.status"/>
            {{ profile.stpAccount.stp_clabe }}
          </p>
        </template>
        <template v-else>
          <vs-button
              @click="createStpAccountHandler()"
              color="success"
              class="small">
            Crear cuenta STP
          </vs-button>
        </template>
      </div>
    </vx-card>

    <vx-card title="Información del crédito">
      <ul>
        <li class="p-1">
          <strong>Monto a financiar:</strong> {{project.financedAmount | currency}}
        </li>
        <li class="p-1">
          <strong>Comisión pre-originación:</strong> {{ project.applicantFee1 | currency }}
        </li>
        <li class="p-1">
          <strong>Comisión de contratación:</strong> {{ project.applicantFee2 | currency }}
        </li>
        <li class="p-1">
          <strong>Monto a dispersar:</strong> {{ project.creditDisposalAmount | currency }}
        </li>
      </ul>
    </vx-card>
  </div>
</template>

<script>
import {Profile} from "@/models/LoanPayment/Profile";
import StpAccountStatusIcon from "@views/admin/SupplierPayment/StpAccountStatusIcon";
import BankAccountSelect from "@components/ui/BankAccountSelect/BankAccountSelect.vue";
import {LoanProject} from "@/models/LoanPayment/Project";

export default {
  name: "participant-profile",
  components: {BankAccountSelect, StpAccountStatusIcon},
  props: {
    project: {
      type: LoanProject,
      required:true
    },
    profile: {
      type: Profile,
      required: true
    }
  },
  mounted() {
    this.$emit("onChangeBankAccount", this.profile.bankAccount)
  },
  methods: {
    changeBankAccountHandler(ev) {
      this.$emit("onChangeBankAccount", ev)
    },
    async createStpAccountHandler() {
      this.$vs.loading()

      try {
        let uri = this.profile.isApplicant() ? '/api/stp/v1/account/applicantId' : '/api/stp/v1/account/supplierId';
        const {data} = await axios.post(`${uri}/${this.profile.id}`)
        this.stpAccount = data;
        this.$vs.loading.close()
      } catch (e) {
        this.$vs.loading.close()
        swal("Error", "Hubo un error al crear la cuenta STP", "error");
      }
    }
  }
}
</script>

<style scoped>

</style>
